'use strict';

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

/**
 * Component that's used to either show or hide own children.
 *
 * Since both `show` and `hide` shouldn't be used at the same time, `hide` has a priority
 *
 * | `hide` | `show` | Component visible? |
 * | ----------- | ----------- | ----------- |
 * | `undefined` | `undefined` | yes |
 * | `undefined` | `true` | yes |
 * | `undefined` | `false` | no |
 * | `true` | (any value) | no |
 * | `false` | (any value) | yes |
 */
function HideComponent({ children, hide, show }) {
    const shouldShow = () => {
        if (typeof hide !== 'undefined') {
            if (hide === true) {
                return false;
            }
            return true;
        }
        if (typeof show === 'undefined' || show === true) {
            return true;
        }
        return false;
    };
    return React__namespace.createElement(React__namespace.Fragment, null, shouldShow() ? children : null);
}

module.exports = HideComponent;
